import { createFA5iconSet } from '@expo/vector-icons/build/createIconSetFromFontAwesome5';
import React from 'react';
import type { ColorValue, StyleProp, ViewStyle } from 'react-native';

import { fontMeta } from './fontMeta';
import { glyphMap } from './glyphMap';

const fontMap = {
  Regular: require('../../assets/fonts/FontAwesome5_Pro_Regular.ttf'),
  Light: require('../../assets/fonts/FontAwesome5_Pro_Light.ttf'),
  Solid: require('../../assets/fonts/FontAwesome5_Pro_Solid.ttf'),
  Brand: require('../../assets/fonts/FontAwesome5_Pro_Brands.ttf'),
};

const FontAwesome5Pro = createFA5iconSet(glyphMap, fontMeta, fontMap, true);

export type IconType = 'regular' | 'light' | 'solid' | 'brand';

export type IconName =
  | (typeof fontMeta.brands)[number]
  | (typeof fontMeta.regular)[number]
  | (typeof fontMeta.light)[number]
  | (typeof fontMeta.solid)[number];

export interface IconProps {
  name: IconName;
  type?: IconType;
  size?: number;
  color?: number | ColorValue | undefined;
  style?: StyleProp<ViewStyle>;
}

export const Icon = ({
  name,
  size,
  color,
  style,
  type = 'regular',
}: IconProps) => {
  return (
    <FontAwesome5Pro
      solid={type === 'solid'}
      light={type === 'light'}
      brand={type === 'brand'}
      name={name}
      size={size}
      color={color}
      style={style}
    />
  );
};
